import { useDispatch, useSelector } from 'react-redux';
import reduxConstants from 'lib/reusable-components/reusableUtils/redux/reduxConstants';
import { create } from 'lib/reusable-components/reusableUtils/redux/stateSlice';
import store from 'lib/reusable-components/reusableUtils/redux/store';
import get from 'lodash.get';

export default function useUpdateJoinTableSchema() {
  const dispatch = useDispatch();
  const schema = useSelector(
    (state) =>
      get(state[reduxConstants.STORE_NAME][reduxConstants.config.APP_SCHEMA], [
        reduxConstants.config.JOIN_TABLE,
      ])
    // state[reduxConstants.STORE_NAME][reduxConstants.config.SCHEMA]),
  );

  /**
   * isDelete - true for delete operation, false for table creation
   * path - The key of table to be deleted
   * newObj - the object of new table in case of table creation
   * key - the key (table ID)
   */
  return (isDelete, path, newObj, key, tableOriginalName) => {
    let newDataTable;
    if (isDelete) {
      newDataTable = { ...schema };
      delete newDataTable[path];
    } else {
      newDataTable = { ...schema, [key]: newObj };
      // When, name of table is being changed delete object with older table name
      // if(tableOriginalName && newObj.tableID !== tableOriginalName) {
      //   delete newDataTable[tableOriginalName];
      // }
    }
    dispatch(
      create({
        setPath: `${reduxConstants.config.APP_SCHEMA}.${reduxConstants.config.JOIN_TABLE}`,
        value: newDataTable,
      })
    );
  };
}
